<template>
  <pre class="raw-json"><code>{{ pretty }}</code></pre>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { SprintDetail } from "@/api/types";

const props = defineProps<{ sprint: SprintDetail }>();
const pretty = computed(() => JSON.stringify(props.sprint, null, 2));
</script>

<style scoped>
.raw-json {
  background: var(--surface-card, #fff);
  border: 1px solid var(--surface-border, #e5e7eb);
  border-radius: 8px;
  padding: 16px;
  overflow: auto;
  max-height: 70vh;
  font-size: 13px;
  line-height: 1.45;
}
</style>
